<script setup>
import { ref, onMounted } from 'vue';

const csrfName = ref('');
const csrf = ref('');

onMounted(() => {
  csrfName.value = document
    .querySelector('meta[name=csrf-param]')
    .getAttribute('content');
  csrf.value = document
    .querySelector('meta[name=csrf-token]')
    .getAttribute('content');
});
</script>

<template>
  <input type="hidden" :name="csrfName" :value="csrf" />
</template>
